import type { Role } from '@ready/shared';

export { ORG_TYPE_LABELS } from '@ready/shared';

export const ROLE_LABELS: Record<Role, string> = {
  learner: 'Learner',
  judge: 'Judge',
  facilitator: 'Facilitator',
  author: 'Author',
  admin: 'Admin',
  owner: 'Owner',
};

export const JOIN_POLICY_LABELS = {
  open: 'Open — verified-domain emails join automatically',
  approval: 'Approval — verified-domain emails request to join',
  invite_only: 'Invite only — domain just suggests this org',
  managed: 'Managed — the org controls accounts (needs SSO)',
} as const;
